var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('n-list',{attrs:{"value":"products","text":"商品","fields":_vm.fields,"items":_vm.products}})}
var staticRenderFns = []

export { render, staticRenderFns }